import hasValueBaseValidator from './hasValue';

export default hasValueBaseValidator;
